export type SlaType = 'USER' | 'SERVICE_LEVEL' | 'NONE';

export const SlaType = {
  USER: 'USER' as SlaType,
  SERVICELEVEL: 'SERVICE_LEVEL' as SlaType,
  NONE: 'NONE' as SlaType,
};
